import { getElementSize, getWindowSize } from '../../utils/dom';
var padding = 8;
var paddings = padding * 2;
export var offset = {
  name: 'offset',
  options: {
    offset: [0, padding]
  }
};
export var overflow = function overflow(container) {
  return {
    name: 'preventOverflow',
    options: {
      boundary: container
    }
  };
};
export var noflip = {
  name: 'flip',
  enabled: false
};
export var dimensions = function dimensions(container) {
  return {
    name: 'calculateDimensions',
    enabled: true,
    phase: 'beforeRead',
    fn: function fn(_ref) {
      var state = _ref.state;
      var controlEl = state.elements.reference;
      var contentEl = state.elements.popper;
      var containerIsBody = container === document.body;
      var box = containerIsBody ? getWindowSize() : getElementSize(container);
      var origin = getElementSize(document.body);
      var control = getElementSize(controlEl);
      var content = getElementSize(contentEl);
      var cbottom = control.bottom - origin.top;
      var ctop = control.top - origin.top;
      var ymax = box.bottom - origin.top;
      var ymin = box.top - origin.top;
      var result = state.modifiersData.dimensions || {};
      result.cbottom = cbottom;
      result.ctop = ctop;
      result.ymin = ymin;
      result.ymax = ymax;
      result.contentHeight = result.contentHeight || content.height;
      state.modifiersData.dimensions = result;
    }
  };
};
export var fit = {
  name: 'calculateFit',
  enabled: true,
  phase: 'beforeRead',
  requires: ['calculateDimensions'],
  fn: function fn(_ref2) {
    var state = _ref2.state;
    var _state$modifiersData$ = state.modifiersData.dimensions,
      ctop = _state$modifiersData$.ctop,
      ymin = _state$modifiersData$.ymin,
      cbottom = _state$modifiersData$.cbottom,
      contentHeight = _state$modifiersData$.contentHeight,
      ymax = _state$modifiersData$.ymax;
    var up = ctop - paddings - contentHeight >= ymin;
    var down = cbottom + paddings + contentHeight <= ymax;
    var availableTopSpace = ctop - ymin;
    var availableBottomSpace = ymax - cbottom;
    var result = state.modifiersData.fit || {
      availableSpaces: {}
    };
    var adaptivePlacement = !!state.modifiersData.adpApplyDirection;
    var initial = 'none';
    if (up) {
      initial = 'top';
    }
    if (down) {
      initial = 'bottom';
    }
    result.initial = initial;
    result.adjusted = !adaptivePlacement || availableBottomSpace >= availableTopSpace ? 'bottom' : 'top';
    result.availableSpaces.top = availableTopSpace - paddings;
    result.availableSpaces.bottom = availableBottomSpace - paddings;
    state.modifiersData.fit = result;
  }
};
export var adpApplyDirection = function adpApplyDirection(container, positioning) {
  return {
    name: 'adpApplyDirection',
    enabled: true,
    phase: 'beforeRead',
    requires: ['calculateFit'],
    fn: function fn(_ref3) {
      var state = _ref3.state;
      var box = container ? getElementSize(container) : getWindowSize();
      var origin = getElementSize(document.body);
      var control = getElementSize(state.elements.reference);
      var content = getElementSize(state.elements.popper);
      var cbottom = control.bottom - origin.top;
      var ymax = box.bottom - origin.top;
      var down = cbottom + padding + content.height <= ymax;
      var placement = down ? 'bottom' : 'top';
      state.placement = "".concat(placement, "-").concat(positioning);
    }
  };
};
export var adhApplyDirection = function adhApplyDirection(positioning) {
  return {
    name: 'adhApplyDirection',
    enabled: true,
    phase: 'beforeRead',
    requires: ['calculateFit'],
    fn: function fn(_ref4) {
      var state = _ref4.state;
      var _state$modifiersData$2 = state.modifiersData.fit,
        initial = _state$modifiersData$2.initial,
        adjusted = _state$modifiersData$2.adjusted;
      if (initial !== 'none') {
        return;
      }
      state.placement = "".concat(adjusted, "-").concat(positioning);
    }
  };
};
export var applyHeight = {
  name: 'applyHeight',
  enabled: true,
  phase: 'write',
  fn: function fn(_ref5) {
    var state = _ref5.state;
    var _a;
    var _state$modifiersData$3 = state.modifiersData.fit,
      initial = _state$modifiersData$3.initial,
      adjusted = _state$modifiersData$3.adjusted,
      availableSpaces = _state$modifiersData$3.availableSpaces;
    var adaptivePlacement = !!state.modifiersData.adpApplyDirection;
    var content = state.elements.popper;
    var customHeightLimit = (_a = content.dataset) === null || _a === void 0 ? void 0 : _a.height;
    if (initial === 'none' || !adaptivePlacement) {
      content.style.maxHeight = availableSpaces[adjusted] + 'px';
    } else if (initial !== 'none' && customHeightLimit) {
      content.style.maxHeight = customHeightLimit + 'px';
    }
  }
};
export var silent = [offset, {
  name: 'eventListeners',
  enabled: false
}, {
  name: 'computeStyles',
  enabled: false
}];